import React, { createContext, useEffect, useState } from 'react';
import axios from 'utils/axios';

const ContractsContext = createContext(null);

export function ContractsProvider({ children }) {
    const [loading, setLoading] = useState(true);
    const [contracts, setContracts] = useState([]);

    const loadContracts = async () => {
        setLoading(true);
        let contractsToReturn = contracts;

        try {
            const { data } = await axios.get('/api/contracts/list');
            setContracts(data);
            contractsToReturn = data;
        } catch (error) {
            console.error('Error fetching contracts:', error);
        }

        setLoading(false);
        return contractsToReturn;
    };

    useEffect(() => loadContracts(), []);

    return <ContractsContext.Provider value={{ contracts, loadContracts, loading }}>{children}</ContractsContext.Provider>;
}

export default ContractsContext;
